export const arrayToDictionary = (arr: string[]): Record<string, string> => {
	return arr.reduce(
		(acc, item) => {
			acc[item] = item;
			return acc;
		},
		{} as Record<string, string>
	);
};
